import { FormFieldTypes } from "../../../data/formFieldType";

export const MemberApplicationTaskListdata = {
  name: "AdditionalInfo",
  initialState: {
    companyNameOrUen: '',
    membershipTypeId: null,
    statusId: null,
  },
  formFields: [
    {
      id: "companyNameOrUen",
      lable: "Company Name/UEN",
      Field_Name: "Company Name/UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyNameOrUen",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
      containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "membershipTypeId",
      lable: "Application Type",
      Field_Name: "Application Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipTypeId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
      containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "statusId",
      lable: "Application Status",
      Field_Name: "Application Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
